module.exports = __webpack_public_path__ + "img/feature_03.6c4dddfd.svg";